import "./logo.css.ts.vanilla.css-mistica.js";
var t = "_140ft6x5", a = "_140ft6x4", e = {
    size: "var(--_140ft6x0)",
    sizeMobile: "var(--_140ft6x1)",
    sizeTablet: "var(--_140ft6x2)",
    sizeDesktop: "var(--_140ft6x3)"
};
export { t as logoContainer, a as svg, e as vars };
